import { action, observable, computed } from 'mobx';
import { ApiUrls } from '@app/AppConstants';
import ApiService from '@app/Services/ApiService';
import { AirportModel } from '@app/Models';
import { PromiseCompletion } from '@app/Classes/PromiseCompletion';

export default class AirportStore {
    @observable airports: AirportModel[] = [];
    private _loader: PromiseCompletion;
    
    constructor(loader: PromiseCompletion){
        this._loader = loader;
        this.loadAirports();
    }
    
    @action
    async loadAirports() {
        const { data: airports } = await ApiService.getTypedData<AirportModel[]>(ApiUrls.AirportUrl, null, { completion: this._loader });
        this.airports = airports;
    }
    
    @computed
    get airportsOptions() {
        return this.airports.map(key => {
            return { key: key.code, text: key.name };
        });
    }

    @computed
    get airportSearchableOptions(){
        return this.airports.map(el => { return {label: el.name, value: el.code}; });
    }
}